var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_94_4",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_94_4",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADoUlEQVR4nO2cy2oUURCGWwQT9Qmi0YipMxEXvoCoC19AXOgbuBA0SxcSk3gBUWJyKrhwFTca8CnEW0yURFdeo27FlWDVEG8tPRkHhLl1p8eaOf1/cJZTXV1fn+ozfYsiAAAAAADQA+wfj7c4lrPkddF5kWQQ6xLNyij5uM86v6BxU7KTvL5wrHG9QawvycugdZ7BHvnEutKo+P9KwEzIHWI53ar4NQmzMpp/BgXHsTxuWwDrknW+weFYvrYrIDkxW+cbHA4CeqgFeV00TrfYJ2Hn5Yx1vsFBPu5zrMttnIBXsAztEPtufBtoJiH5kzYyKzs6tX0Q1S5F/KonYOBWvA1F+g84Lz/rCYjuxZshAALCx2EG1Arxu+2lYcAjMjwSIYAhIMYM6II24NCC7AvhcA4o5oi67SQcxfGmKEAcBNgCAcZAgDEQYAwEGAMBxkCAMRBgDAQYAwHGQEBRBTS6BdgwoQzXggan4q2OZdKxvCeWNWJZJS+XNvKkw4Hr8fYkRiUWy1oS23mZSLaVJV7qi3R5PSTQaQGD68Wv++ghsT7NImG9+LpYN6aXR0NzcX/amMEKINbxZvGSozhtzuTlStOYrGNpY4YrwMubFgI+pM2ZWD42FyCv08YMVoBj0RbF+pE25+Q3eb9DUNwZwLKa+wzw8iptzIAF6IXmMWUybc7Ecrn5DNDzaWMGK2BoLu4nlocNWsWTLMvGZOXkWBcaHP0PsAqqK0HHHMtb56XsvLzbyJq9trz1MlGNVU5aXbKNLMUPegb0ChBgDAQYAwHGQIAxEGBM4QQ4lvtpd7rOWMgjl0IKKLEebPRGZHuj8ttDUU4UTkBC5Y9UVgFeLkY5YibA+ulox3I17c6Tl2v559Gg0EV4PL3EcqzVFc5q4T85luNRByi0gL9vyQ97PUFe7lbv71Y/2le55ztfYj3Zye9EFF6ANRBgDAQYAwHGQIAxEGAMBBgDAcZAgDE9IyD1Rau49T/n6qMrt/PYXt4jCl3A8E3dRV6fWRe6kALctB52Xj9bF7mQApyXU+Tlu3WBCydgqIv7ffAChru833eVgLzvH5DXI636ffLcP3k9Z70vPUkzAa6Nfk+sX0oz5aPW+xGcAGKZb2OqP987o7ut96GnyXzO8HIHH+Y2EEDo93YCCP3eVMDyyHR5TwdSKDZtCfDo9yYCCP3echmqWN9bCSDWFfR7KwEe/d5EAPq9oQD0e0Owvjcm6ycCAAAAAACivPkDdZFa9DrcGtcAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBot);
export default __webpack_public_path__ + "static/media/MessageBot.55407a21833f8a39d4adb1fab10f4bdf.svg";
export { ForwardRef as ReactComponent };